import { render, staticRenderFns } from "./NationalTrademarkCountryList.vue?vue&type=template&id=48c87e04&"
import script from "./NationalTrademarkCountryList.vue?vue&type=script&lang=js&"
export * from "./NationalTrademarkCountryList.vue?vue&type=script&lang=js&"
import style0 from "./NationalTrademarkCountryList.vue?vue&type=style&index=0&id=48c87e04&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports